/**
 * A tier rendered as the design shows it — "6 correct" — since the tier a reward paid at IS its
 * correct-count (CONTEXT → Prize tier). Null (an unresolved tier) reads as an em-dash, never
 * "null correct". Shared by every Award surface so the tier reads identically wherever it appears.
 */
export function tierLabel(tier: number | null): string {
  return tier === null ? '—' : `${tier} correct`;
}
